import { render, staticRenderFns } from "./Quotation.vue?vue&type=template&id=318ed16e&scoped=true"
import script from "./Quotation.vue?vue&type=script&lang=js"
export * from "./Quotation.vue?vue&type=script&lang=js"
import style0 from "@/assets/pdf/css/default.less?vue&type=style&index=0&id=318ed16e&prod&scoped=true&lang=less&external"
import style1 from "./Quotation.vue?vue&type=style&index=1&id=318ed16e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318ed16e",
  null
  
)

export default component.exports